module.exports = __webpack_public_path__ + "static/img/lasting_impressions_about_d.17b5f02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lasting_impressions_about_d.jpg
// module id = 704
// module chunks = 1